module.exports = __webpack_public_path__ + "static/img/stage-warn-active.c2cac38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/stage-warn-active.png
// module id = JB6V
// module chunks = 58